const GA_ID = "G-XR9S7MTFS4";

export function trackEvent(name, params = {}) {
  if (!window.gtag) return;
  window.gtag("event", name, { ...params, send_to: GA_ID });
}